// extracted by mini-css-extract-plugin
module.exports = {"product":"ProductGrid_product__1jiwE","thumb":"ProductGrid_thumb__3NHKX","content":"ProductGrid_content__AnvON","price":"ProductGrid_price__3IU2F"};